import { forwardRef, useId } from 'react';
import './Select.css';

const ChevronIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path d="M4 6l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

// Styled native <select> — kept native (rather than a custom listbox) so
// keyboard, screen reader, and mobile behavior all come for free.
const Select = forwardRef(function Select(
  { label, error, helperText, children, className = '', id, ...rest },
  ref
) {
  const autoId = useId();
  const selectId = id || autoId;
  const describedBy = error ? `${selectId}-error` : helperText ? `${selectId}-helper` : undefined;

  return (
    <div className={`ds-field ${className}`.trim()}>
      {label && (
        <label htmlFor={selectId} className="ds-field-label">
          {label}
        </label>
      )}
      <div className={`ds-select-wrap ${error ? 'ds-select-wrap-error' : ''}`}>
        <select
          ref={ref}
          id={selectId}
          className="ds-select"
          aria-invalid={error ? true : undefined}
          aria-describedby={describedBy}
          {...rest}
        >
          {children}
        </select>
        <span className="ds-select-chevron">
          <ChevronIcon />
        </span>
      </div>
      {error && (
        <span id={`${selectId}-error`} className="ds-field-error" role="alert">
          {error}
        </span>
      )}
      {!error && helperText && (
        <span id={`${selectId}-helper`} className="ds-field-helper">
          {helperText}
        </span>
      )}
    </div>
  );
});

export default Select;
